import axios from 'axios';

export default {
  getAllParentCategories: function () {
    return axios.get('parent-categories/all')
      .then((response) => {
        return response.data;
      })
  },

  index(query: any = null, is_paginate = true) {
    return new Promise((resolve, reject) => {
      axios.get('categories', {
        params: query
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      })
    })
  },
  store(payload: any) {
    return axios.post('categories', payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  show(id: any) {
    return axios.get('categories/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  update(id: any, payload: any) {
    return axios.put('categories/' + id, payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  destroy(id: any) {
    return axios.delete('categories/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  metaSync(payload: any) {
    return axios.post('categories/sync-metatags', payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },

  getAllCategories: function () {
    return axios.get('all-categories/')
      .then((response) => {
        return response.data;
      })
  },
  subCategoryIndex(currentPage = null, query: any = null, is_paginate = true) {
    return new Promise((resolve, reject) => {
      let params = {page: currentPage, pagination: is_paginate}
      params = {...query, ...params};

      axios.get('sub-categories', {
        params: params
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      })
    })
  },
  subCategoryStore(payload: any) {
    return axios.post('sub-categories', payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  subCategoryShow(id: any) {
    return axios.get('sub-categories/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  subCategoryUpdate(id: any, payload: any) {
    return axios.put('sub-categories/' + id, payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  subCategoryDestroy(id: any) {
    return axios.delete('sub-categories/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  }
}
